module.exports = __webpack_public_path__ + "media/images/posts/no_social_sites-76530c76c546003c4859d92921e9c576.jpg";